<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <div class="response-container">
      <h1>PCS 06 API Response</h1>
      <b-row>
        <b-col md="3">
          <label>MSG Name</label>
          <b-form-input
            :formatter="capitalizeAll"
            disabled
            id="MSG_NAME"
            name="MSG_NAME"
            v-model="MSG_NAME"
          ></b-form-input
        ></b-col>
        <b-col md="3">
          <label>MSG IDENTIFIER (KOCU4351870)</label>
          <b-form-input
            :formatter="capitalizeAll"
            id="MSG_IDENTIFIER"
            name="MSG_IDENTIFIER"
            v-model="MSG_IDENTIFIER"
          ></b-form-input
        ></b-col>
        <b-col md="3">
          <b-button
            v-if="MSG_NAME && MSG_IDENTIFIER"
            @click="getAllPCS06Func()"
            size="sm"
            variant="info"
            style="font-size: 0.675rem; margin-left: 5px; margin-bottom: 4px"
            >Fetch</b-button
          >
        </b-col>
      </b-row>
      <hr />
      <div
        v-if="
          !getAllPcs06 ||
          !getAllPcs06.response ||
          getAllPcs06.response.map.Description ||
          getAllPcs06.responseStatus === 'not found'
        "
      >
        <b class="text-danger">{{ "No data found." }}</b>
      </div>
      <div v-else>
        <!-- {{ getAllPcs06.response }} -->
        <b-row>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Gross Quantity:</strong>
            {{
              getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map
                .GrossQtyVolume
            }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Seal No:</strong>
            {{
              getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map.SealNo
            }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>No of Packages:</strong>
            {{
              getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map
                .NoofPackages
            }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>SMTP Date:</strong>
            {{
              getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map.SMTPDate
            }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Container Type:</strong>
            {{
              getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map
                .ContainerType
            }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Destination Code:</strong>
            {{
              getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map
                .DestinationCode
            }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Customs House Code:</strong>
            {{
              getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map
                .CustomsHouseCode
            }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Bond No:</strong>
            {{
              getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map.BondNo
            }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Container No:</strong>
            {{
              getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map
                .ContainerNo
            }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Cargo Description:</strong>
            {{
              getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map.CargoDesc
            }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Line Number:</strong>
            {{
              getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map
                .LineNumber
            }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Unit of Packages:</strong>
            {{
              getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map
                .UnitofPackages
            }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>IGM Date:</strong>
            {{
              getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map.IGMDate
            }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>SMTP No:</strong>
            {{
              getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map.SMTPNo
            }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Consignee Name:</strong>
            {{
              getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map
                .ConsigneeName
            }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>IGM No:</strong>
            {{ getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map.IGMNo }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Sub Line Number:</strong>
            {{
              getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map
                .SubLineNumber
            }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Carrier Code:</strong>
            {{
              getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map
                .CarrierCode
            }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Terminal Operator Code:</strong>
            {{
              getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map
                .TerminalOperatorCode
            }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Unit of Quantity:</strong>
            {{
              getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map.UnitofQty
            }}
          </b-col>
          <b-col md="3" class="mt-1 mb-1">
            <strong>Message Type:</strong>
            {{
              getAllPcs06.response.map.CHPOI13Payload.map.manifest.map.trans.map
                .MessageType
            }}
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import UlipService from "../../services/UlipService.js";
import CustomLoader from "../common/customLoader.vue";
import { globalPermissionStatus } from "../../helper/collection";
export default {
  beforeMount() {
    this.$store.dispatch("setCurrentRoute", this.$route.path);
    if (globalPermissionStatus("Dashboard_Access") || globalPermissionStatus("ULIP")) {
      // this.getAllPCS06Func();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      MSG_IDENTIFIER: "",
      MSG_NAME: "CHPOI13",
      getAllPcs06: null,
      isLoading: false,
      error: false,
      code: 200,
      message: "Success",
    };
  },

  filters: {},

  mounted() {},

  beforeDestroy() {},

  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    CustomLoader,
  },

  methods: {
    async getAllPCS06Func() {
      let payload = {};
      this.isLoading = true;
      this.getAllPcs06 = null;

      if (this.MSG_IDENTIFIER && this.MSG_NAME) {
        payload = {
          itemCode: "PCS06",
          funcUrl: "PCS/06",
          MSG_IDENTIFIER: this.MSG_IDENTIFIER,
          MSG_NAME: this.MSG_NAME,
        };

        payload = JSON.stringify(payload);
        UlipService.getAllUlipList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
              console.log("getAllPcs06 PS =>", data.getAllPcs06.response.response);
              if (
                data.getAllPcs06.response.response &&
                data.getAllPcs06.response.response.length > 0
              ) {
                this.getAllPcs06 = data.getAllPcs06.response.response[0];
              }
              this.isLoading = false;
            }
          })
          .catch((error) => {
            console.log("Catch on getAllPcs06 Error: ", error);
          });
      }
    },
  },
};
</script>

<style scoped>
.response-container {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

h1 {
  font-size: 24px;
  margin-bottom: 20px;
}

ul {
  list-style: none;
  padding: 0;
}

li {
  margin-bottom: 10px;
  font-size: 18px;
}

strong {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// PCS06_ResponseDisplay.vue?c8dafc5e